<template>
    <v-dialog v-model="dialog" style="width: 100%;" persistent>
        
        <v-card>
            
            <v-app-bar class="mb-5 d-flex" flat color="transparent" style="justify-content: flex-end;">
                <v-btn color="error" @click="$emit('cancel')">Cancelar</v-btn>
                <v-btn color="primary" @click="$emit('exportPdf')" class="ml-3">Gerar PDF</v-btn>
            </v-app-bar>
            <!-- <v-container id="jobReferance" class="pdf-content"> -->
            <div id="conteudoPDF">
                <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                    <v-col cols="3">
                        <v-img src="@/assets/logo_delta.jpg" contain height="90" />
                    </v-col>
                    <v-col cols="9" class="text-right">
                        <h2 class="mb-0">Lista de Fornecedores</h2>

                        <span v-if="filters?.filterdescricaoMaterial">
                            <strong>Material Fornecido: </strong>{{ filters?.filterdescricaoMaterial || '' }}
                        </span>
                        <span v-if="filters?.idFornecedor">
                            <strong>Fornecedor: </strong>{{ filters?.idFornecedor?.idFornecedor || '' }}
                        </span>
                    </v-col>
                </div>

                <v-card outlined class="pa-10">
                    <template>
                        <div class="tabela" id="conteudoPDF">
                            <div class="linha header">
                                <div class="cel codigo">CÓD.</div>
                                <div class="cel contato">CONTATO</div>
                                <div class="cel">DEPTO</div>
                                <div class="cel telefone">TELEFONE</div>
                                <div class="cel ramal">RAMAL</div>
                                <div class="cel celular">CELULAR</div>
                            </div>

                            <!-- Renderizando cada grupo de cliente -->
                            <div v-for="cliente in dadosTabela" :key="cliente._id">
                                <!-- Linha do cliente -->
                                <div class="linha cliente">
                                    <div class="cel codigo">{{ cliente.codigo }}</div>
                                    <div class="cel contato">{{ cliente.nomeFantasia }}</div>
                                    <!-- <div class="cel depto">{{ cliente.razaoSocial }}</div> -->
                                    <div class="cel telefone"></div>
                                    <div class="cel ramal"></div>
                                    <div class="cel celular"></div>
                                </div>

                                <!-- Detalhes do cliente -->
                                <div class="linha detalhe" v-for="(detalhe, index) in cliente.contatos"
                                    :key="`${cliente._id}-${index}`">
                                    <div class="cel codigo"></div>
                                    <div class="cel contato">{{ detalhe.nome }}</div>
                                    <div class="cel">{{ detalhe.departamento }}</div>
                                    <div class="cel telefone">{{ detalhe.telefone }}</div>
                                    <div class="cel ramal">{{ detalhe.ramal }}</div>
                                    <div class="cel celular">{{ detalhe.celular }}</div>
                                </div>

                                <div v-for="(material) in cliente.materiais"
                                    :key="material._id" 
                                    class="linha subdetalhe"
                                >

                                    <div class="cel codigo">
                                        <strong>Material Fornecido:</strong>
                                    </div>
                                    <div class="cel contato">↳ {{ material.materialFornecedorDescricao }}</div>
                                </div>

                            </div>

                        </div>
                    </template>

                </v-card>
            </div>

            <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="$emit('cancel')">Cancelar</v-btn>
                <v-btn color="primary" @click="$emit('exportPdf')">Gerar PDF</v-btn>
            </v-card-actions> -->

        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'RelatorioFornecedorPreview',
    props: ['isOpen', 'dadosTabela', 'filters'],
    data() {
        return {
            dialog: false
        }
    },
    watch: {
        isOpen(value){
            this.dialog = value;
        }
    },
}
</script>

<style scoped>

.tabela {
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  font-family: sans-serif;
  font-size: 14px;
  width: 100%;
}

.linha {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 2fr 1fr 1fr; /* 6 colunas */
  border-bottom: 1px solid #ddd;
}

.header {
  background-color: #eee;
  font-weight: bold;
}

.cliente {
  background-color: #dce6f1;
  font-weight: bold;
}

.detalhe {
  background-color: #fff;
}

/* 🔹 Subtabela */
.subdetalhe {
  background-color: #f9f9f9;
  font-size: 13px;
  padding-left: 20px;
}

.cel {
  padding: 6px 10px;
  border-right: 1px solid #e0e0e0;
}

.cel:last-child {
  border-right: none;
}

</style>